module.exports = __webpack_public_path__ + "img/ic_hotel_card_star_1.fb8e82b4.svg";